import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import RenderProfilePicture from '../../../../_helpers/profile-picture'

import { AsyncPaginate } from "react-select-async-paginate";
import { patientService } from '../../../../_services/patient.service'
import '../style.css'

class PatientSearch extends Component {
  constructor(props) {
    super(props)

    this.axiosInstance = axios.create()
    this.handleChange = this.handleChange.bind(this)
    this.handleLoadOptions = this.handleLoadOptions.bind(this)
  }

  handleChange(selected) {
    let patient = ''

    if (selected) {
      patient = { value: selected.id, label: `${selected.firstName} ${selected.lastName}` }
    }
    this.props.handleSelected(patient)
  }

  async handleLoadOptions(term, callback, { page }) {
    const name = term.split(" ")

    const searchParams = {
      firstName: name[0] || '',
      lastName: name.length > 1 ? name[1] : '',
      page: page || ''
    }
    const response = await patientService.retrieve(searchParams)
    const responseData = await response;

    return {
      options: responseData.collection.data,
      hasMore: responseData.total > responseData.lastIndex,
      additional: {
        page: responseData.nextPage
      }
    }
  }

  render() {
    const CustomOption = ({ innerProps, isDisabled, ...props }) => {
      return <div {...innerProps} className='custom__option'>
        <div className='row p-3'>
          <div className='col-3'>
            <RenderProfilePicture image={props.data.profile} circle cached={false} width={40} height={40} className='m-auto' />
          </div>
          <div className='col-9'>
            <div>
              {`${props.data.firstName} ${props.data.lastName}`}
            </div>
            <div style={{ fontSize: 'small' }} className="font-weight-light">
              {moment(props.data.dateOfBirth).format('MM/DD/YYYY')}
            </div>
          </div>
        </div>
      </div>
    }

    return (
      <AsyncPaginate
        isClearable
        key={JSON.stringify(this.props.patient)}
        value={this.props.patient}
        onChange={this.handleChange}
        loadOptions={this.handleLoadOptions}
        className={this.props.invalid ? 'is-invalid' : ''}
        placeholder="Patient"
        additional={{
          page: 1,
        }}
        styles={{
          menu: (styles) => {
            return { ...styles, zIndex: 99, width: 250 }
          }
        }}
        components={{ Option: CustomOption }}
      />
    )
  }
}

export default PatientSearch
